import React from 'react'
import { Seo } from '~/components/molecules/Seo'
import { Props, Screen } from '~/components/screens/press-release'
import { GetStaticPaths, GetStaticProps } from 'next'
import {
  getAllPressReleases,
  getPressReleaseBySlug,
  getPressReleaseFooterContent,
} from '~/services/PressReleaseService'
import { ParsedUrlQuery } from 'querystring'
import { serialize } from 'next-mdx-remote/serialize'
import { site } from '~/config'
import { OpenGraphMedia } from 'next-seo/lib/types'
import { stripMarkdown } from '~/utils'

const Page = (props: Props) => {
  let socialImage: OpenGraphMedia | undefined
  const socialTitle = props.pressRelease.title

  if (props.pressRelease.featureImage != undefined) {
    socialImage = {
      url: `${site.host}${props.pressRelease.featureImage}`,
    }
  }

  return (
    <>
      <Seo
        title={`Press Release | ${socialTitle}`}
        image={socialImage}
        description={props.pressRelease.description}
      />
      <Screen {...props} />
    </>
  )
}

export default Page

interface StaticPathsParams extends ParsedUrlQuery {
  slug: string
}

export const getStaticPaths: GetStaticPaths<StaticPathsParams> = async () => {
  const pressReleases = getAllPressReleases()
  const paths = pressReleases.map((pr) => {
    return {
      params: {
        slug: pr.slug,
      },
    }
  })
  return {
    paths,
    fallback: false,
  }
}

export const getStaticProps: GetStaticProps<Props, StaticPathsParams> = async ({
  params,
}) => {
  const pressRelease = getPressReleaseBySlug(params.slug)
  const mdx = await serialize(pressRelease.markdown)

  const useBanklessFooter = params.slug == 'geolocation-triggered-payment'

  const footerMdx = useBanklessFooter
    ? await serialize('')
    : await serialize(getPressReleaseFooterContent())

  if (!pressRelease.description) {
    pressRelease.description =
      stripMarkdown(pressRelease.markdown).slice(0, 240) + '...'
  }
  delete pressRelease.markdown

  return {
    props: {
      pressRelease,
      mdx,
      footerMdx,
      useBanklessFooter,
    },
  }
}
